const toAPAAuthors = paper => {
  const authorStrings = paper?.authors.map(author => {
    const family = author?.family
    const initials = author?.given?.split(' ')
      .map(name => name.slice(0, 1) + '.')
      .join(' ')
    if (family && initials) {
      return `${family}, ${initials}`
    } else if (family) {
      return family
    }
    return ''
  })?.filter(author => !!author)

  if (!authorStrings) {
    return
  }

  if (authorStrings.length <= 6) {
    return authorStrings.join(', ')
  }

  return authorStrings.slice(0, 6).join(', ') + ', … & ' + authorStrings.slice(-1)[0]
}

export const toAPAReference = paper => {
  const authors = toAPAAuthors(paper).trim()
  const title = paper.title || 'Untitled'
  const year = paper.year
  const journal = paper.shortJournal || paper.journal
  const issue = paper.issue
  const volume = paper.volume
  const page = paper.page

  let result = ''

  if (authors) {
    result += authors
  }

  if (year) {
    result += ` (${year}).`
  }

  result += ` ${title}.`

  if (journal) {
    result += ` ${journal}`
  }

  if (issue) {
    result += `, ${issue}`
  } else if (volume) {
    result += ', '
  }

  if (volume) {
    result += `(${volume})`
  }

  if (page) {
    result += `, ${page}`
  }

  result += `. https://doi.org/${paper.doi}`

  return result
}
